import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Selectors from '../redux/selectors';
import { ResultList } from '../components/ResultList';
import { loadMoreRequestAction } from '../redux/actions';
import { buildUpSellUrl } from '../utils/buildUpSellUrl';

const ResultListContainer = (props) => {
  const { dispatch, texts, offers, selectedOrderBy, hasMore, showLoading, isFetching } = props;

  const handleLoadMore = useCallback(() => {
    dispatch(loadMoreRequestAction());
  }, [dispatch]);

  const handleBuildUpSellUrl = useCallback(
    (node, offer) => {
      return buildUpSellUrl(node, offer, texts?.upsellLink?.href?.url);
    },
    [texts],
  );

  return (
    <ResultList
      offers={offers}
      texts={texts}
      orderBy={selectedOrderBy}
      hasMore={hasMore}
      isFetching={isFetching}
      showLoading={showLoading}
      onLoadMore={handleLoadMore}
      onBuildUpsellUrl={handleBuildUpSellUrl}
    />
  );
};

ResultListContainer.propTypes = {
  dispatch: PropTypes.func,
  texts: PropTypes.object,
  offers: PropTypes.array,
  selectedOrderBy: PropTypes.string,
  hasMore: PropTypes.bool,
  showLoading: PropTypes.bool,
  isFetching: PropTypes.bool,
};

function mapStateToProps(state) {
  const query = Selectors.getQueryParams(state);

  return {
    offers: Selectors.getFlightOffers(state),
    selectedOrderBy: query.orderBy,
    hasMore: Selectors.hasMoreFlights(state),
    isFetching: Selectors.isFetching(state),
    showLoading: Selectors.showLoading(state),
  };
}

export const ConnectedResultListContainer = connect(mapStateToProps)(ResultListContainer);

export default ConnectedResultListContainer;
